import type { NextPage } from 'next';
import HomePageTransferAssetView from '@components/HomePageTransferAssetView';
import AirdropBanner from '@components/AirdropBanner';
import InformationBanner from '@components/InformationBanner';
import TransferAssetFlowProvider from '@providers/TransferAssetFlowProvider';

const Home: NextPage = () => {
  return (
    <>
      <TransferAssetFlowProvider>
        <AirdropBanner />
        <InformationBanner />
        <HomePageTransferAssetView />
      </TransferAssetFlowProvider>
    </>
  );
};

export default Home;
